import Mutations from '../../odata/mutations';

export default { ...new Mutations('pickingList'), ...new Mutations('pickingLists') };
